import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Navimumbaitopunedailycab() {



  const cardData = {
    keyword: " Navi Mumbai to Pune Daily cab Service ",


"headingDescription": "Royal Route Cab offers reliable Navi Mumbai to Pune daily cab service, providing safe, comfortable, and punctual intercity travel for office commuters, business professionals, students, and frequent travelers. The Navi Mumbai to Pune route is approximately 150–170 km and takes around 3–4 hours via the Mumbai–Pune Expressway. Our daily cab service is designed for regular travelers who need consistent pickup and drop service between both cities with flexible scheduling and dedicated vehicles. We ensure timely pickups, smooth highway travel, and professional drivers experienced with daily intercity routes. Our fleet includes hatchbacks, sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for individuals and groups. With 24/7 availability, transparent pricing, and easy booking, Royal Route Cab is a trusted choice for Navi Mumbai to Pune daily cab service.",

"topPlaces": [
  {
    "title": "Mumbai–Pune Expressway Travel",
    "description": "The Mumbai–Pune Expressway is one of the fastest and safest highways in India, making daily cab travel between Navi Mumbai and Pune smooth and efficient. It offers well-maintained roads, scenic mountain views, and multiple rest stops along the way. Daily commuters benefit from predictable travel times, reduced fatigue, and a comfortable driving experience even during peak traffic hours. This expressway route is the backbone of intercity daily cab services."
  },
  {
    "title": "Hinjewadi IT Park",
    "description": "Hinjewadi IT Park is Pune’s largest IT hub and a major destination for daily commuters from Navi Mumbai. It hosts numerous multinational companies, tech parks, and corporate offices. Daily cab services are widely used by employees traveling for work, offering timely arrival, comfortable seating, and stress-free office commute without the hassle of public transport."
  },
  {
    "title": "Pune City Center",
    "description": "Pune City Center is a key destination for business, education, and commercial activities. Daily cab services connect Navi Mumbai professionals to areas like Shivajinagar, Camp, and Deccan. It provides a reliable travel solution for meetings, office work, and academic commuting, ensuring consistent and punctual transportation."
  },
  {
    "title": "Corporate Daily Commute",
    "description": "Many companies and professionals rely on daily cab services for regular intercity commuting between Navi Mumbai and Pune. It offers a cost-effective and comfortable alternative to trains and buses. Fixed schedules, professional drivers, and dedicated vehicles ensure reliability and productivity for daily office travelers."
  },
  {
    "title": "Educational Travel Route",
    "description": "Students and faculty members traveling between Navi Mumbai and Pune use daily cab services for universities, coaching institutes, and colleges. The service provides safe, timely, and comfortable travel, making it easier for students to manage long-distance education without relocation."
  },
  {
    "title": "Flexible Pickup & Drop Points",
    "description": "Daily cab service allows flexible pickup and drop locations across Navi Mumbai and Pune including Vashi, Nerul, Belapur, Kharghar, Hinjewadi, Wakad, and Shivajinagar. This flexibility ensures maximum convenience for passengers with different work or travel schedules."
  },
  {
    "title": "One-Way & Monthly Packages",
    "description": "Passengers can choose between one-way daily rides or monthly subscription-based cab packages depending on their travel frequency. Monthly packages are cost-effective for regular commuters, offering fixed pricing and guaranteed availability without daily booking hassle."
  },
  {
    "title": "Comfortable Long Commute Travel",
    "description": "Daily intercity travel can be tiring, so comfortable vehicles with air-conditioning, spacious seating, and smooth suspension are used to ensure a relaxed journey. This helps passengers travel long distances daily without fatigue, maintaining productivity and comfort."
  },
  {
    "title": "24/7 Availability",
    "description": "Navi Mumbai to Pune daily cab services operate round the clock to support early morning office departures and late-night returns. This ensures that commuters always have reliable transportation regardless of shift timings or work schedules."
  },
  {
    "title": "Safe & Reliable Driver Service",
    "description": "All daily cab services are operated by experienced and verified drivers familiar with intercity routes. They ensure safe driving on highways, punctual pickups, and professional behavior, making daily travel secure, comfortable, and stress-free for passengers."
  }
],






services: [
  {
    name: "Navi Mumbai to Pune Daily Cab Service",
    description: "Navi Mumbai to Pune daily cab service offers reliable and comfortable transportation for daily commuters, IT professionals, and business travelers. This service ensures fixed timing, punctual pickups, and smooth expressway travel. Clean vehicles and professional drivers enhance convenience. It guarantees a stress-free daily journey."
  },
  {
    name: "Navi Mumbai to Pune Cab Service",
    description: "Navi Mumbai to Pune cab service provides flexible and dependable travel for intercity journeys. Ideal for personal, corporate, and family travel. Comfortable vehicles ensure smooth highway rides. It guarantees a safe and convenient experience."
  },
  {
    name: "Navi Mumbai to Pune Taxi Service",
    description: "Navi Mumbai to Pune taxi service offers private and comfortable travel with door-to-door pickup. This service is suitable for one-way and round trips. Professional drivers ensure safety. It guarantees a reliable journey."
  },
  {
    name: "Navi Mumbai to Pune Cab Booking",
    description: "Navi Mumbai to Pune cab booking allows customers to reserve rides easily with instant confirmation. Users can select vehicle type, pickup location, and timing. Transparent pricing ensures trust. It simplifies travel planning."
  },
  {
    name: "Navi Mumbai to Pune Taxi",
    description: "Navi Mumbai to Pune taxi provides convenient and efficient intercity travel for individuals and groups. Comfortable seating and smooth driving ensure a pleasant journey. It guarantees reliable transportation."
  },
  {
    name: "Navi Mumbai to Pune One Way Cab",
    description: "Navi Mumbai to Pune one way cab offers cost-effective travel without return charges. Ideal for single-side trips. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Navi Mumbai to Pune Cab Fare",
    description: "Navi Mumbai to Pune cab fare is transparent and depends on vehicle type and travel plan. Customers receive clear pricing before booking. No hidden charges ensure trust. It helps in planning travel costs."
  },
  {
    name: "Navi Mumbai to Pune Cab Price",
    description: "Navi Mumbai to Pune cab price varies based on car selection and trip duration. Budget and premium options are available. Transparent pricing ensures convenience. It helps in easy planning."
  },
  {
    name: "Navi Mumbai to Pune Cab Booking Online",
    description: "Navi Mumbai to Pune cab booking online provides a fast and convenient way to reserve rides. Secure payment and instant confirmation enhance the booking experience. It ensures hassle-free travel planning."
  },
  {
    name: "Daily Cab from Navi Mumbai to Pune",
    description: "Daily cab from Navi Mumbai to Pune is ideal for regular commuters and office travel. Fixed schedules and reliable service ensure consistency. Comfortable vehicles enhance daily travel experience. It guarantees punctual journeys."
  },
  {
    name: "Navi Mumbai to Pune Corporate Cab Service",
    description: "Navi Mumbai to Pune corporate cab service offers professional transportation for business travelers and employees. This service ensures punctual pickups, clean vehicles, and trained drivers. It guarantees efficient corporate travel."
  },
  {
    name: "Navi Mumbai to Pune Airport Cab",
    description: "Navi Mumbai to Pune airport cab provides direct transfer services for airport travelers. Ideal for connecting flights and long-distance travel. Professional drivers ensure timely service. It guarantees a stress-free journey."
  }
],

tableData: [
  ["Navi Mumbai to Pune Daily Cab Service", "Navi Mumbai to Pune Cab Service"],
  ["Navi Mumbai to Pune Taxi Service", "Navi Mumbai to Pune Cab Booking"],
  ["Navi Mumbai to Pune Taxi", "Navi Mumbai to Pune One Way Cab"],
  ["Navi Mumbai to Pune Cab Fare", "Navi Mumbai to Pune Cab Price"],
  ["Navi Mumbai to Pune Cab Booking Online", "Daily Cab from Navi Mumbai to Pune"],
  ["Navi Mumbai to Pune Corporate Cab Service", "Navi Mumbai to Pune Airport Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Navi Mumbai to Pune Daily Cab Service",
    WhyChoosedescription: "Royal Route Cabs offers dependable daily cab service from Navi Mumbai to Pune, ideal for office commuters, IT professionals, and frequent travelers."
  },
  {
    WhyChooseheading: "Affordable Daily Travel Pricing",
    WhyChoosedescription: "Daily cab fares are budget-friendly with packages starting from ₹1800–₹3000, making regular travel cost-effective."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on the Mumbai–Pune Expressway, ensuring safe, fast, and smooth daily journeys."
  },
  {
    WhyChooseheading: "Flexible Pickup & Drop Locations",
    WhyChoosedescription: "We provide pickup from all Navi Mumbai areas and drop across Pune including Hinjewadi, Wakad, Baner, and Magarpatta."
  },
  {
    WhyChooseheading: "24/7 Daily Cab Availability",
    WhyChoosedescription: "Our service operates round the clock, perfect for early office travel, late-night returns, and shift-based employees."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and sanitized regularly for comfortable daily commuting."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, and premium vehicles for a comfortable ride."
  },
  {
    WhyChooseheading: "Trusted Daily Travel Partner",
    WhyChoosedescription: "Royal Route Cabs is trusted by daily commuters for Navi Mumbai to Pune cab service due to punctuality and reliable drivers."
  }
]

};

const faqData = [
  { question: "Do you provide daily cab service from Navi Mumbai to Pune?", answer: "Yes, Royal Route Cabs offers daily cab service for regular commuters between Navi Mumbai and Pune." },
  { question: "What is the distance between Navi Mumbai and Pune?", answer: "The distance is approximately 150 to 170 km via Mumbai–Pune Expressway." },
  { question: "What is the daily cab fare?", answer: "Daily cab fare typically starts from ₹1800 to ₹3000 depending on vehicle type." },
  { question: "How much time does it take?", answer: "Travel time is around 3 to 4 hours depending on traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our daily cab service operates 24/7." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles." },
  { question: "Do you provide monthly packages?", answer: "Yes, we offer monthly and corporate packages for regular users." },
  { question: "Can I customize pickup and drop?", answer: "Yes, pickup and drop locations can be customized as per your requirement." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended to secure your preferred time slot." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Patil",
    feedback:
      "Using daily cab from Navi Mumbai to Pune. Very punctual and comfortable ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "Best daily cab service. Clean car and professional driver.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Pune Daily Cab Service",
  "image": "https://www.royalroutecabs.com/assets/images/navi-mumbai-to-pune-daily-cab.jpg", // replace if needed
  "description": "Book Navi Mumbai to Pune daily cab service with Royal Route Cabs for reliable, comfortable, and affordable intercity travel. Available for one-way, round-trip, corporate, and airport transfers with sedan, SUV, Innova, and chauffeur-driven taxi options.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3400",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499", // indicative one-way fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/navi-mumbai-to-pune-daily-cab-service"
  }
};






  return (
    <div>

<Helmet>
  <title>Navi Mumbai to Pune Daily Cab Service | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Navi Mumbai to Pune daily cab service with Royal Route Cabs. Affordable and reliable intercity taxi for daily travel, one-way trips, corporate cab service, and airport transfers."
  />

  <meta
    name="keywords"
    content="navi mumbai to pune daily cab service, navi mumbai to pune cab service, navi mumbai to pune taxi service, navi mumbai to pune cab booking, navi mumbai to pune taxi, navi mumbai to pune one way cab, navi mumbai to pune cab fare, navi mumbai to pune cab price, navi mumbai to pune cab booking online, daily cab from navi mumbai to pune, navi mumbai to pune corporate cab service, navi mumbai to pune airport cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/107.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitopunedailycab;